import request from '../utils/request';

export const goodsCategoryApi = {
  /**
   * 获取商品分类树状结构
   * @param {Object} params - 查询参数
   * @param {number} [params.status] - 可选的状态过滤
   * @returns {Promise} 商品分类树状结构
   */
  getCategoryTree: (params = {}) => {
    return request({
      url: '/category/tree',
      method: 'get',
      params
    });
  },

  /**
   * 获取商品分类列表
   * @param {Object} params - 查询参数
   * @param {number} [params.status] - 可选的状态过滤
   * @returns {Promise} 商品分类列表
   */
  getCategoryList: (params = {}) => {
    return request({
      url: '/category/list',
      method: 'get',
    });
  },

  /**
   * 创建商品分类
   * @param {Object} data - 分类数据
   * @returns {Promise} 创建结果
   */
  createCategory: (data) => {
    return request({
      url: '/category',
      method: 'post',
      data
    });
  },

  /**
   * 更新商品分类
   * @param {Object} data - 分类数据
   * @returns {Promise} 更新结果
   */
  updateCategory: (data) => {
    return request({
      url: '/category',
      method: 'put',
      data
    });
  },

  /**
   * 删除商品分类
   * @param {number} id - 分类ID
   * @returns {Promise} 删除结果
   */
  deleteCategory: (id) => {
    return request({
      url: `/category/${id}`,
      method: 'delete'
    });
  }
};

export default goodsCategoryApi; 